import { create } from "zustand";
import { STORAGE_KEYS } from "../constants/storage";

export interface HistoryItem {
  name: string;
  code: string;
  market: string;
  totalScore: number;
  gradeEng: string;
  analyzedAt: string;
  years: number;
}

const STORAGE_KEY = STORAGE_KEYS.history;
const MAX_ITEMS = 10;

function load(): HistoryItem[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function save(items: HistoryItem[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

interface HistoryState {
  history: HistoryItem[];
  addHistory: (item: HistoryItem) => void;
  removeHistory: (code: string) => void;
}

export const useHistoryStore = create<HistoryState>((set) => ({
  history: load(),
  addHistory: (item) =>
    set((state) => {
      const filtered = state.history.filter((h) => !(h.code === item.code && h.years === item.years));
      const next = [item, ...filtered].slice(0, MAX_ITEMS);
      save(next);
      return { history: next };
    }),
  removeHistory: (code) =>
    set((state) => {
      const next = state.history.filter((h) => h.code !== code);
      save(next);
      return { history: next };
    }),
}));
